import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { AuthenticateService } from './authenticate.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-authenticate-insight',
  templateUrl: './authenticate.component.html',
  styleUrls: ['./authenticate.component.scss']
})
export class AuthenticateComponent implements OnInit {

  formGroup: FormGroup;
  username: FormControl<string>;
  password: FormControl<string>;
  reCaptchaResponse: FormControl<string>;

  errorMessage = '';
  isSubmitting: boolean;
  formSubmitAttempt = false;

  constructor(
    public dialogRef: MatDialogRef<AuthenticateComponent>,
    private authenticateService: AuthenticateService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.username = new FormControl('', [Validators.required]);
    this.password = new FormControl('', [Validators.required]);
    this.formGroup = this.formBuilder.group({
      username: this.username,
      password: this.password
    });
  }

  submit() {
    console.log('submitting');
    this.isSubmitting = true;
    this.formSubmitAttempt = true;
    if (this.formGroup.invalid) {
      console.log('formGroup.invalid');
      this.isSubmitting = false;
      return;
    }

    const credentials = this.formGroup.value;
    this.authenticateService.authenticate(credentials).subscribe((userId: number) => {
      this.isSubmitting = false;
      this.dialogRef.close(userId);
    }, err => {
      this.isSubmitting = false;
      this.errorMessage = err.error.data;
    });
  }
}
